import { useState } from 'react';
import { MonitoringTab } from '@odo/shared-ui';
import { usePatientCard } from '../../../hooks/usePatientCard';
import { dmScansQueryConfig } from '../../../services/dmScans';
import { RowMenu } from '../../billing/RowMenu';
import { ManageMonitoringButton } from './ManageMonitoringButton';
import { RejectedScansModal } from './RejectedScansModal';

interface MonitoringTabPanelProps {
    patientId: string;
    /** Only hosts that render DmControlRoute can open the DM control modal. */
    canManageMonitoring?: boolean;
}

function MonitoringTabPanel({ patientId, canManageMonitoring = false }: MonitoringTabPanelProps) {
    const { data } = usePatientCard(patientId);
    const [showRejectedScans, setShowRejectedScans] = useState(false);
    const dmId = data?.monitoring?.dmId ?? null;

    if (!dmId) {
        return (
            <div className="flex items-center justify-center flex-1 min-h-[200px] text-sm text-gray-400">
                No Dental Monitoring data for this patient
            </div>
        );
    }

    return (
        <div className="flex flex-col flex-1 min-h-0 p-5">
            <MonitoringTab
                queries={dmScansQueryConfig}
                patientId={patientId}
                dmId={dmId}
                allowFullscreen
                totalAligners={data?.monitoring?.totalAligners ?? null}
                monitoringStatus={data?.monitoring?.monitoringStatus}
                currentAligner={data?.monitoring?.currentAligner ?? null}
                headerActions={
                    canManageMonitoring && <ManageMonitoringButton patientId={patientId} />
                }
                detailsMenu={
                    <RowMenu
                        size="compact"
                        label="Scan options"
                        items={[
                            { label: 'Rejected scans', onClick: () => setShowRejectedScans(true) }
                        ]}
                    />
                }
            />
            {showRejectedScans && (
                <RejectedScansModal
                    patientId={patientId}
                    onClose={() => setShowRejectedScans(false)}
                />
            )}
        </div>
    );
}

export { MonitoringTabPanel };
